// Mock data for Limpid Reader - all content sourced from limpidreader.art.blog

export const SITE = {
  name: 'Limpid Reader',
  tagline: 'BEYOND THE PAGES',
  logo: 'https://limpidreader.art.blog/wp-content/uploads/2025/09/img_1414.png',
  email: 'lucidreader10@gmail.com',
  authorLinktree: 'https://linktr.ee/the_s3ntongo',
  heroImage: 'https://mobilelinkslayout2.files.wordpress.com/2021/01/matthew-henry-kq3mxxdgeom-unsplash-edit.jpg',
  intro:
    'Connecting readers with knowledge, imagination, and meaningful conversations that extend far beyond the written word.',
};

export const SOCIALS = [
  { name: 'Instagram', icon: 'Instagram', url: 'https://www.instagram.com/limpid_reader' },
  { name: 'X', icon: 'Twitter', url: 'https://x.com/limpid_reader' },
  { name: 'Threads', icon: 'AtSign', url: 'https://www.threads.com/@limpid_reader' },
  { name: 'Facebook', icon: 'Facebook', url: 'https://www.facebook.com/Limpidreader' },
  { name: 'LinkedIn', icon: 'Linkedin', url: 'https://www.linkedin.com/company/lucid-reader/' },
  { name: 'Telegram', icon: 'Send', url: 'https://t.me/Limpid_reader' },
  { name: 'TikTok', icon: 'Music2', url: 'https://www.tiktok.com/@limpid_reader' },
  { name: 'Snapchat', icon: 'Ghost', url: 'https://www.snapchat.com/@limpidreader' },
  { name: 'Pinterest', icon: 'Image', url: 'https://www.pinterest.com/limpid_reader10/' },
  { name: 'Email', icon: 'Mail', url: 'mailto:lucidreader10@gmail.com' },
];

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Buy A Book', path: '/buy' },
  { label: 'Echoes Of My Mind', path: '/echoes' },
  { label: 'Read Online', path: '/read-online' },
  { label: 'About Us', path: '/about' },
  { label: 'Magazines', path: '/magazines' },
  { label: 'Ratings & Reviews', path: '/reviews' },
  { label: 'Our Services', path: '/services' },
];

const U = 'https://limpidreader.art.blog/wp-content/uploads';
const PDF = 'https://customer-assets-7cd3h4nn.emergentagent.net/job_limpid-shop/artifacts';

export const BOOKS = [
  {
    id: 'uncolonized',
    title: 'UNCOLONIZED',
    subtitle: 'The Return Of My Mind',
    front: `${U}/2026/08/front-cover.jpg`,
    back: `${U}/2026/08/back-cover-6.jpeg`,
    physical: 25,
    digital: 0,
    free: true,
    pdf: `${PDF}/yx4v0ofo_UNCOLONIZED%20The%20Return%20of%20My%20Mind.pdf`,
    tag: 'Identity & Power',
    blurb:
      'A searing reflection on decolonising the mind—reclaiming thought, culture, and identity from the systems that sought to define them.',
  },
  {
    id: 'mothering-kawadwa',
    title: 'Mothering Kawadwa',
    subtitle: 'A Portrait of Grit & Grace',
    front: `${U}/2026/03/a7f72787-07d3-4247-adab-6dc52f97a579.png`,
    back: `${U}/2026/08/back-cover-1.jpeg`,
    physical: 30,
    digital: 0,
    free: true,
    pdf: `${PDF}/7rn9b2rx_Mothering%20Kawadwa%20Edition%201.pdf`,
    tag: 'Bestseller',
    featured: true,
    blurb:
      'A raw, unfiltered look at the intersection of gender, race, and poverty—stripping away romanticized myths of motherhood to honour the grit of African women.',
  },
  {
    id: 'crowned-by-illusion',
    title: 'Crowned By Illusion',
    subtitle: 'The Architecture of Power',
    front: `${U}/2026/04/bedf2ca2-4eaf-46af-9f7f-319dcfd070ae.png`,
    back: `${U}/2026/08/back-cover-2.jpeg`,
    physical: 24,
    digital: 0,
    free: true,
    pdf: `${PDF}/oho8qrw4_CROWNED%20BY%20ILLUSION%20FULL%20MANUSCRIPT.pdf`,
    tag: 'History & Power',
    blurb:
      'A historical blueprint detailing how figures used reputation, fame, and calculation to gain absolute control.',
  },
  {
    id: 'my-last-3-years-to-30',
    title: 'My Last 3 Years to 30',
    subtitle: 'A Memoir of Becoming',
    front: `${U}/2026/04/0fb0e67b-97fb-4d30-84d6-291d109e081f.png`,
    back: `${U}/2026/08/back-cover-3.jpeg`,
    physical: 18,
    digital: 12,
    tag: 'Memoir',
    blurb:
      'An intimate reckoning with time, ambition, and self—three years chronicled on the road to thirty.',
  },
  {
    id: 'time',
    title: 'Time',
    subtitle: 'The Currency We Cannot Keep',
    front: `${U}/2026/09/front-cover.jpeg`,
    back: `${U}/2026/09/back-cover.jpeg`,
    physical: 15,
    digital: 0,
    free: true,
    pdf: `${PDF}/0jrkyqch_TIME.pdf`,
    tag: 'Philosophy',
    blurb:
      'A meditation on the one resource none of us can save—exploring how we spend, waste, and honour the hours we are given.',
  },
  {
    id: 'edge-of-oblivion',
    title: 'Edge Of Oblivion',
    subtitle: 'Standing at the Precipice',
    front: `${U}/2026/04/img_3419-1.jpg`,
    back: `${U}/2026/09/back-cover-2.jpeg`,
    physical: 20,
    digital: 0,
    free: true,
    pdf: `${PDF}/bcyaaxbu_EDGE%20OF%20OBLIVION%20FULL%20MANUSCRIPT.pdf`,
    tag: 'Human Condition',
    blurb:
      'A daring exploration of the moments that push us to the brink—and what it means to step back from the edge.',
  },
  {
    id: 'echoes-of-my-mind',
    title: 'Echoes Of My Mind',
    subtitle: 'Collected Reflections',
    front: `${U}/2026/07/image_editor_output_image-172349592-1783682307074997721681919015083.jpg`,
    back: `${U}/2026/08/back-cover-5.jpeg`,
    physical: 16,
    digital: 0,
    free: true,
    pdf: `${PDF}/ekcymxim_ECHOES%20OF%20MY%20MIND%20the%20S3ntongo%20Codes.pdf`,
    tag: 'Essays',
    blurb:
      'A collection of thought-provoking essays and reflections blending personal experience with philosophy, history, and science.',
  },
];

export const SERVICES = [
  { icon: 'BookOpen', title: 'Digital Bookstore', desc: 'Discover and access carefully selected non-fiction books across a wide range of subjects, authors, and perspectives.' },
  { icon: 'PenTool', title: 'Publishing', desc: 'Helping authors transform manuscripts into professionally edited, designed, published, and distributed books.' },
  { icon: 'CheckCheck', title: 'Editing & Proofreading', desc: "Refining manuscripts through professional editing, proofreading, and structural guidance while preserving the author's voice." },
  { icon: 'Users', title: 'Author Support & Development', desc: 'Supporting emerging and established writers with manuscript guidance, publishing advice, book development, and literary direction.' },
  { icon: 'MessagesSquare', title: 'Reading Community', desc: 'Creating spaces where readers can connect, discuss books, exchange ideas, join reading groups, and discover new perspectives together.' },
  { icon: 'CalendarHeart', title: 'Literary Events & Book Experiences', desc: 'Curating book launches, author conversations, reading sessions, literary gatherings, and other experiences that take reading beyond the pages.' },
];

export const REVIEWS = [
  {
    name: 'Dennise',
    rating: 5,
    book: 'Crowned By Illusion',
    text: 'I loved how it reads like a massively popular historical blueprint detailing how historical figures used reputation, fame, and calculation to gain absolute control.',
  },
  {
    name: 'Jeremy Conner',
    rating: 5,
    book: 'Mothering Kawadwa',
    text: "Critics have long praised Faisal's work for its raw, unfiltered look at the intersection of gender, race, and poverty. He strips away the romanticized myths of motherhood, replacing them with a fierce, heartbreaking reality that honours the grit of African women.",
  },
  {
    name: 'Ruth Nambatya',
    rating: 5,
    book: 'Limpid Reader',
    text: "Amazing quality! It's rare to find something that checks all the boxes, but this did. I'll be recommending it to everyone I know!",
  },
];

export const TEAM = {
  name: 'Faisal K. Sentongo',
  role: 'Founder, CEO & Author',
  photo: `${U}/2026/08/aaaa.jpeg`,
  bio: 'A Ugandan author, technology professional, and creative entrepreneur driven by a deep belief in the power of knowledge and meaningful stories.',
};

export const ABOUT = {
  hero: `${U}/2026/08/img-20260618-wa0133.jpg`,
  mission:
    'To make knowledge clear, ideas accessible, and stories impossible to forget—by discovering, publishing, preserving, and bringing meaningful non-fiction to every curious mind, giving readers the power to understand the world, question what they know, and see beyond what they have been told.',
  vision:
    "To become a home for the world's most meaningful non-fiction—a living library where ideas travel beyond borders, forgotten voices find their pages, knowledge outlives its authors, and every reader leaves seeing the world a little more clearly than before.",
  intro:
    'Limpid Reader is a digital library and bookstore dedicated exclusively to non-fiction. It exists to inform, educate, and inspire through knowledge. From biographies to science, philosophy to politics, and lifestyle, Limpid Reader offers a curated collection of thought-provoking works. More than just books, it provides engaging and educational non-fiction that both enlightens and entertains.',
};

export const FAQS = [
  {
    q: 'How can I benefit from Limpid Reader?',
    a: 'Anyone can benefit from Limpid Reader by gaining access to meaningful non-fiction that informs, challenges, and expands the way they understand the world. Whether you are a reader seeking knowledge, an author looking for a platform, a student searching for reliable ideas, or simply someone curious about people, history, culture, science, and life, Limpid Reader offers a space to discover valuable stories and perspectives.',
  },
  {
    q: 'Who is behind Limpid Reader?',
    a: 'Limpid Reader was founded by Faisal K. Sentongo, a Ugandan author, technology professional, and creative entrepreneur driven by a deep belief in the power of knowledge and meaningful stories. What began as a vision for a dedicated home for non-fiction has grown into a literary platform committed to discovering, publishing, preserving, and making important ideas, experiences, histories, and voices accessible to curious minds everywhere.',
  },
  {
    q: "I'd like to meet fellow readers, how can I do that?",
    a: 'Limpid Reader is designed to bring readers together. Through our reading community, discussions, book clubs, literary events, and shared recommendations, you can connect with people who share your curiosity and love for ideas.',
  },
  {
    q: 'Can I apply to be a part of the team or work as a contractor?',
    a: 'Yes. Limpid Reader welcomes talented individuals who believe in the power of books, knowledge, and ideas. Opportunities may be available across publishing, editing, writing, design, technology, marketing, research, and community development.',
  },
];

export const MAGAZINES = [
  {
    title: 'Shadow Vogue',
    issue: '2026 — Issue 01',
    volume: 'Shadow Vogue Vol. 1',
    cover: `${U}/2026/08/whatsapp-image-2026-07-08-at-13.25.22.jpeg`,
    link: 'https://shadowvogue10.blogspot.com/',
    download: `${U}/2026/08/shadow-vogue-vol-1.pdf`,
    desc: 'A bold visual journal exploring culture, art, and the aesthetics of the unseen.',
  },
];

export const ECHOES = [
  {
    title: 'Beyond The Pages',
    date: 'September 2026',
    excerpt:
      'Our non-fiction writing centers on identity, truth, culture, power, and the human condition, often blending personal reflection with philosophy, history, and science.',
    image: `${U}/2026/08/bbbbb.jpeg`,
  },
  {
    title: 'The Return Of My Mind',
    date: 'August 2026',
    excerpt:
      'Reclaiming thought from inherited systems—an essay on what it means to think freely in a world designed to think for us.',
    image: `${U}/2026/08/img-20260618-wa0133.jpg`,
  },
  {
    title: 'Read Clearly. Think Deeply.',
    date: 'July 2026',
    excerpt:
      'Reflections on reading as an act of resistance, and why clarity of thought begins with clarity of the page.',
    image: `${U}/2026/08/img-20260618-wa0160.jpg`,
  },
];

// Original teaser excerpts written for preview purposes (not the actual book text)
export const SAMPLES = {
  'uncolonized': [
    'They handed me a map of my own mind and called it a gift. For years I walked its borders without asking who drew them, or why the roads always led away from home.',
    'This is the story of unlearning — of tracing every inherited thought back to its source, and deciding, at last, which ones were ever mine to keep.',
  ],
  'mothering-kawadwa': [
    'Before the sun found the hills, she was already awake, counting the small victories that no one would ever record.',
    'To mother here is to bargain with hunger and still find a song. This is a portrait of that quiet, ferocious grace.',
  ],
  'crowned-by-illusion': [
    'Power rarely announces itself. It arrives dressed as charm, as certainty, as the story everyone agrees to believe.',
    'Turn the page and watch how crowns are built — not from gold, but from the willingness of others to look away.',
  ],
  'my-last-3-years-to-30': [
    'At twenty-seven the clock stops being a friend and starts keeping score. I began writing to see where the years had gone.',
    'What follows is a ledger of ambition and doubt — three years measured not in birthdays, but in the person I was becoming.',
  ],
  'time': [
    'We spend it before we understand it, and mourn it only when it is gone.',
    'A meditation on the one currency none of us can save — and what it might mean to spend it well.',
  ],
  'edge-of-oblivion': [
    'There is a moment, right at the brink, when the world grows very quiet and very honest.',
    'This book lives in that moment — at the edge where fear and clarity finally meet.',
  ],
  'echoes-of-my-mind': [
    'Some thoughts refuse to stay silent. They return, softened and sharpened, until you finally write them down.',
    'A collection of reflections that began as whispers and grew into something worth sharing.',
  ],
};

export const PROMO_HINTS = [
  { code: 'WELCOME10', label: '10% off your first order' },
  { code: 'READ5', label: '$5 off any order' },
];
